export default __webpack_public_path__ + "static/media/Kakarotto.28c37228.png";